/**
 * The client Your Plan and its report are calculated from.
 *
 * With self-funding included it is the client as it is. Without it (a consumer who never bought
 * self-funding access, or whose access has expired) it is a copy with the self-funding accounts taken
 * out and every figure recalculated, so combined coverage and the gap count insurance only, on screen
 * and in the report alike. The saved accounts themselves are never touched.
 */
import { cloneDeep } from 'lodash';
import { calcClientDerivatives } from '../calculations/calcClientDerivatives';

export function buildYourPlanClient(
  client: Client,
  { includeSelfFunding }: { includeSelfFunding: boolean },
): Client {
  if (includeSelfFunding) return client;
  const withoutSelfFunding = cloneDeep(client);
  withoutSelfFunding.multipleFundingSources.selfFunding = {};
  return calcClientDerivatives(withoutSelfFunding, client.mutableClientPartner ?? null) as Client;
}
